// ABOUTME: Screen 2C What Felt True: the stored storm and its reveal, read from the 2B pick alone (never the weather).
// ABOUTME: The storm cloud's arrows go back to 2B; accept_rule sends nothing.

import { useCrossingContent } from '../../../hooks/useCrossingContent';
import type { ScreenProps, ScreenResult } from '../runner/screenContract';
import ArrivalStatus from './clouds/ArrivalStatus';
import { revealFor } from './clouds/reveal';

// Only seen if the crossing reaches 2C without a stored storm, which the server does not allow.
const MISSING_STORM_HEADLINE = "Let's look at what felt close.";

export default function Screen2C({ crossing, runner }: ScreenProps): ScreenResult {
  const { data: content } = useCrossingContent();
  const storm = crossing.storm ? content?.storms?.[crossing.storm] : undefined;
  const reveal = revealFor(storm);
  const back = () => runner.back();

  return {
    // The reveal is drawn by the stack; this announces it once, on arrival, since focus lands on the screen wrapper.
    layer: <ArrivalStatus text={reveal ? `${reveal.heading}. ${reveal.text}` : ''} />,
    cloudTiers: { storm: { item: storm, onPrev: back, onNext: back, prevLabel: 'Previous storm', nextLabel: 'Next storm' } },
    headline: storm ? `“${storm.plainPhrase}.”` : MISSING_STORM_HEADLINE,
    sub: 'That was the Storm that felt closest this time.',
  };
}
